import {ChangeDetectorRef, Component, Input, OnDestroy} from '@angular/core';
import {CommandsService} from '@app/app/shared/services/commands.service';
import {Subscription} from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';

@Component({
  templateUrl: './park-switcher.html',
  selector: 'park-switcher'
})

export class ParkSwitcherComponent implements OnDestroy {
  @Input() isOn;
  @Input() park_id;
  @Input() id;

  public isRunningOn = false;
  public isRunningOff = false;

  private timerSub: Subscription;

  constructor(private comm: CommandsService, private cdRef: ChangeDetectorRef) {
    //
  }

  public isTurnedOn() {
    const isTurnedOn = this.isOn;

    if (isTurnedOn && this.isRunningOn) {
      this.isRunningOn = false;
      this.cdRef.detectChanges();
    }

    return isTurnedOn;
  }

  public isTurnedOff() {
    const isTurnedOff = !this.isOn;

    if (isTurnedOff && this.isRunningOff) {
      this.isRunningOff = false;
      this.cdRef.detectChanges();
    }

    return isTurnedOff;
  }

  public onChange(event) {
    if (this.isRunningOff || this.isRunningOn) {
      return;
    }

    if (this.isOn) {
      this.isRunningOff = true;
    } else {
      this.isRunningOn = true;
    }

    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }

    this.comm.switchSplashpadMode(this.park_id, this.id, this.isOn).then((res) => {
      this.timerSub = Observable.of(true).delay(15000).subscribe(() => {
        if (this.isRunningOn && !this.isOn) {
          alert('Timed Out');
        }

        if (this.isRunningOff && this.isOn) {
          alert('Timed Out');
        }

        this.isRunningOn = false;
        this.isRunningOff = false;
      });
    }).catch((err) => {
      this.isRunningOn = false;
      this.isRunningOff = false;

      alert(err);
    });
  }

  ngOnDestroy() {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/switcher/park-switcher.component.ts